import React, { Suspense } from 'react';
import { Switch, useLocation, Route, Redirect } from 'react-router-dom';
import { Alert, Loading } from 'Components/nui';
import { FormattedMessage } from 'react-intl';
import type { LazyRoute } from '~/router/useLazyRoutes';

type IView = (props: Record<string, never>) => React.ReactElement;
interface IRoutingTable {
  routes?: IView[];
  redirect?: string;
  lazyRoutes: LazyRoute[];
  children?: React.ReactNode;
}
export const RoutingTable = ({
  routes = [],
  redirect,
  lazyRoutes,
  children,
  ...props
}: IRoutingTable) => {
  const location = useLocation();
  return (
    <Switch location={location} {...props}>
      {routes.map((route) => route({}))}
      {children}
      {redirect && <Redirect to={redirect} />}

      {lazyRoutes?.map(({ path, component }) => (
        <Route key={path} path={path}>
          <Suspense fallback={<Loading />}>{component}</Suspense>
        </Route>
      ))}

      {(lazyRoutes?.length > 0 || lazyRoutes === null) && (
        <Route>
          <PageNotFound />
        </Route>
      )}
    </Switch>
  );
};

const PageNotFound = () => {
  return (
    <Alert type="error">
      <FormattedMessage
        id="router-page-not-found"
        defaultMessage="Page not found"
      />
    </Alert>
  );
};
